import { ExpandableMenuType } from './types';

export const expandableMenuLabel = {
  [ExpandableMenuType.APPS_FOR_PRODUCTS]: 'Apps for products',
  [ExpandableMenuType.CATEGORIES]: 'Categories',
  [ExpandableMenuType.RESOURCES]: 'Resources',
  [ExpandableMenuType.REGULATED_SECTORS]: 'Regulated sectors',
};
